import { AppDate } from '../envTypes';
import { Profile } from './profile';

export enum ModerationStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  ReviewRequired = 'ReviewRequired',
}

export type ModerationAuditLog = {
  approverName: string;
  message: string;
  status: ModerationStatus;
  timestamp: AppDate;
  userId: string;
};

export interface ContentModerationInfo {
  moderationStatus: ModerationStatus;
  moderatedAt?: AppDate;
  moderatorProfile?: Pick<
    Profile,
    'firstName' | 'lastName' | 'username' | 'avatar'
  > & { fullName: string };
  moderatorUserId?: 'AI' | string;
  // admin can provide his own reason for approval or disapproval
  adminModerationReason?: string;
  aiModerationReason?: string;
}
